// src/helpers/ignore-url.ts
var matchUrl = (url, urlList) => {
  return urlList.some((urlItem) => {
    if (urlItem === "") {
      return false;
    }
    return url.match(urlItem);
  });
};
var shouldIgnoreUrl = (url, config) => {
  if (url === "") {
    return false;
  }
  const isIgnored = matchUrl(url, config.ignoreUrls);
  const isAuthorized = config.authorizeUrls ? matchUrl(url, config.authorizeUrls) : true;
  return isIgnored || !isAuthorized;
};

export { shouldIgnoreUrl };
//# sourceMappingURL=chunk-5E3LDJWR.js.map
//# sourceMappingURL=chunk-5E3LDJWR.js.map